import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';

import type { ConversationActionWithAssistantMetadata } from './action-capabilities';
import { getConversationActionWithAssistantMetadata } from './getConversationActionWithAssistantMetadata';

export const getActionPresentation = (
	action: ConversationAction | undefined,
): NonNullable<ConversationActionWithAssistantMetadata['presentation']> =>
	getConversationActionWithAssistantMetadata(action)?.presentation ?? {};
